export interface OwnerPayload {
  id: number | null;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  profile_image?: string | null;
  sex?: string | null;
}

export function formatKey(key: string): string {
  return key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
}

export function extractFieldEntry(raw: unknown): { value: string; unit: string } {
  if (raw != null && typeof raw === 'object' && 'value' in raw) {
    const obj = raw as { value?: unknown; measurement_unit?: string | null };
    return {
      value: obj.value != null ? String(obj.value) : '',
      unit: obj.measurement_unit ?? '',
    };
  }
  return { value: raw != null ? String(raw) : '', unit: '' };
}

export function getStandardValue(
  sv: Record<string, unknown>,
  specLabel: string
): { value: string; unit: string } | undefined {
  const labelLower = specLabel.toLowerCase();
  const raw =
    sv[specLabel] != null
      ? sv[specLabel]
      : Object.entries(sv).find(([k]) => formatKey(k).toLowerCase() === labelLower)?.[1];
  if (raw == null) return undefined;
  return extractFieldEntry(raw);
}

export function combineShoeSizeDisplay(sv: Record<string, unknown>): string {
  const size = getStandardValue(sv, 'Size');
  const sizeType = getStandardValue(sv, 'Size Type');
  const sizeDisplay = size?.value ?? '';
  const sizeTypeDisplay = sizeType?.value ?? '';
  if (sizeDisplay && sizeTypeDisplay) return `${sizeDisplay} ${sizeTypeDisplay}`;
  if (sizeDisplay) return sizeDisplay;
  if (sizeTypeDisplay) return sizeTypeDisplay;
  return 'N/A';
}
